// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'test',
  // front app old URL
  oldAppURL: 'https://test-developer.fisglobal.com',
  appBaseUrl: 'https://test-docs.worldpay.com',
  apiHost: 'https://test-docs.worldpay.com/api',
  contentHost: 'https://test-docs.worldpay.com/api',
  apiKey: '7htms2jKCO221ES39CnOt9B4Bg5nkyTW3bH01Uqa', // API key for request authentication
  selfcertApiHost: "https://cert-eapi.fisglobal.com",
  genApiHost: 'https://test-eapi.fisglobal.com',
  UserPoolId: 'us-east-2_msWalRZ1x',
  // NO HTTPS, ONLY BASE URL
  AppWebDomain: 'auth.test-docs.worldpay.com',
  ClientId: '4ec52jt0scltnukkm6og1s0nmq',
  RedirectUriSignIn: 'https://test-docs.worldpay.com/index.html',
  RedirectUriSignOut: 'https://test-docs.worldpay.com/account/logout/',
  TokenScopesArray: ['email', 'phone', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
  instanaKey: '',
  hotjar: '',
  googleAnalytics: 'G-R6EW9XR9RQ',
  googleAnalyticsUrl: 'https://www.googletagmanager.com/gtag/js?id=',
  content: '../../../catalyst-content/content',
  pendoApiKey: 'bb88e7bb-ad27-40d7-4d24-0c4d8c28dacb',
  pendoAccountId: 'DevEngine',
  pendoUrl: 'https://cdn.pendo.io/agent/static/',
  // splunk RUM Init
  splunkScriptUrl: 'https://cdn.observability.splunkcloud.com/o11y-gdi-rum/v3.0.0/splunk-otel-web.js',
  splunkAppName: 'Worldpay Developer Dashboard',
  splunkRumAccessToken: 'GLgX6hXj47JA-gsAtFkOoA',
  splunkDeploymentEnvironment: 'certification',
  splunkRecorderScriptUrl: 'https://cdn.observability.splunkcloud.com/o11y-gdi-rum/v3.0.0/splunk-otel-web-session-recorder.js',
  // Salesforce web to lead form configurations
  sfLeadSubmissionURL:
    'https://payments--nauat.sandbox.my.salesforce-sites.com/servlet/servlet.WebToLead?encoding=UTF-8', // salesforce web to lead form submission url
  sfOrgId: '00DU8000005wYBL', // salesforce web to lead configuration for organization Id
  sfCampaignID: '7013h000000ULBBAA4', // salesforce web to lead configuration for campaign Id
  sfRecordType: '0123h000000MnxaAAC',
  marketoCodeId: '975-BCU-707',
  marketoCodeSrcUrl: '//munchkin.marketo.net/munchkin.js',
};
